export default "__VITE_ASSET__d8f5277d__"